export default {
  order: {
    title: "Ordine",
    pickupDate: "Data ritiro",
    pickup: "Luogo di ritiro",
    dropoff: "Luogo di destinazione",
    passenger: "Passeggero",
    comment: "Commento",
    vehicle: "Veicolo",
    chauffeur: "Autista",
    passengersCount: "Passeggeri",
    childSeats: "Seggiolini per bambini",
    flightNumber: "Numero volo",
    nameSign: "Cartello con nome",
    speaks: "Parla",
    call: "Chiama",
    licensePlate: "Targa",
    category: "Categoria",
    status: {
      new: "Conferma in attesa",
      confirmed: "Ordine confermato",
      on_my_way: "In viaggio",
      at_the_location: "Arrivato sul posto",
      pob: "Passeggero a bordo",
      clear: "Ordine completato",
      no_show: "Passeggero non si è presentato",
      canceled: "Ordine annullato"
    },
    statusDescriptions: {
      new: "Ordine in attesa di conferma del fornitore",
      confirmed: "Fornitore ha confermato l'ordine, in attesa di inizio",
      on_my_way: "Autista in viaggio verso il luogo di ritiro",
      at_the_location: "Autista arrivato e attende il passeggero",
      pob: "Passeggero salito a bordo, in viaggio verso la destinazione",
      clear: "Ordine completato con successo",
      no_show: "Il passeggero non si è presentato al luogo di ritiro",
      canceled: "Ordine annullato"
    },
    messages: {
      noChauffeurAssigned: "Il tuo autista non è ancora stato assegnato",
      detailsWillAppear: "I dettagli appariranno qui una volta assegnati",
      unknown: "Sconosciuto",
      started: "Iniziato",
      awaitingAssignment: "In attesa di assegnazione"
    },
    childSeatsTypes: {
      child_01: "Navicella (6 mesi)",
      child_02: "Seggiolino convertibile (0-7 anni)",
      child_03: "Alzatore (6-12 anni)"
    },
    distance: "{distance} km",
    review: "Valuta il tuo viaggio",
    review_status: {
      perfect: 'Perfetto',
      good: 'Buono',
      average: 'Nella media',
      bad: 'Scarso',
      terrible: 'Terribile'
    }
  },
  common: {
    save: "Salva",
    cancel: "Annulla",
    loading: "Caricamento...",
    error: "Errore"
  }
}